import { ObjectWithId } from "utils/ObjectWithId";

import { useGetPaymentQuery } from "../api/Payments";

export interface UsePaymentParams extends ObjectWithId {
  options?: {
    refetchOnReconnect?: boolean;
    skip?: boolean;
  };
}

export function usePayment({ id, options }: UsePaymentParams) {
  const { currentData, isLoading, isFetching, isError } = useGetPaymentQuery(
    { id },
    options
  );

  return {
    payment: currentData,
    isPaymentLoading: isLoading,
    isPaymentFetching: isFetching,
    isPaymentError: isError,
  };
}
